<ng-container>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Compare Documents</h5>
  </div>
  <div class="modal-body" ngbAutofocus>
    <div>
      <p>Please select a document to compare with:</p>
      <app-dc-table
        #table
        class="no-footer rounded doc-table"
        [columns]="columns"
        [rows]="rows"
        [messages]="messages"
        [sort]="sortOrder"
        (activate)="docSelect($event)"
      ></app-dc-table>
    </div>
    <div *ngIf="loading" class="loadingState">
      <app-dc-loading></app-dc-loading>
    </div>
  </div>
  <div class="modal-footer justify-content-right">
    <button type="button" class="btn btn-secondary btn-sm" (click)="cancel()">
      Cancel
    </button>
  </div>
</ng-container>
